module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper"
  }, [_c('Header', {
    staticClass: "black"
  }), _vm._v(" "), _c('div', {
    staticClass: "main"
  }, [_c('div', {
    staticClass: "tabbar"
  }, [_c('ul', {
    staticClass: "clearfix"
  }, [_c('li', {
    class: {
      'on': _vm.panelType == 1
    },
    on: {
      "click": function($event) {
        return _vm.onTabBar(1)
      }
    }
  }, [_vm._v("视频案例")]), _vm._v(" "), _c('li', {
    class: {
      'on': _vm.panelType == 2
    },
    on: {
      "click": function($event) {
        return _vm.onTabBar(2)
      }
    }
  }, [_vm._v("制作人")]), _vm._v(" "), _c('li', {
    class: {
      'on': _vm.panelType == 3
    },
    on: {
      "click": function($event) {
        return _vm.onTabBar(3)
      }
    }
  }, [_vm._v("艺人")]), _vm._v(" "), _c('li', {
    class: {
      'on': _vm.panelType == 4
    },
    on: {
      "click": function($event) {
        return _vm.onTabBar(4)
      }
    }
  }, [_vm._v("场地")]), _vm._v(" "), _c('li', {
    class: {
      'on': _vm.panelType == 5
    },
    on: {
      "click": function($event) {
        return _vm.onTabBar(5)
      }
    }
  }, [_vm._v("器材")])])]), _vm._v(" "), (_vm.panelType == 3) ? _c('div', {
    staticClass: "panelbar"
  }, [_c('a', {
    class: {
      on: _vm.panelbar == 1
    },
    on: {
      "click": function($event) {
        return _vm.onPanelBar(1)
      }
    }
  }, [_vm._v("演员")]), _vm._v(" "), _c('a', {
    class: {
      on: _vm.panelbar == 3
    },
    on: {
      "click": function($event) {
        return _vm.onPanelBar(3)
      }
    }
  }, [_vm._v("KOL")]), _vm._v(" "), _c('a', {
    class: {
      on: _vm.panelbar == 4
    },
    on: {
      "click": function($event) {
        return _vm.onPanelBar(4)
      }
    }
  }, [_vm._v("配音")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "panels"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', [(_vm.panelType == 1 && !_vm.caseList.length || _vm.panelType == 2 && !_vm.producerList.length || _vm.panelType == 3 && !_vm.actorList.length || _vm.panelType == 4 && !_vm.venueList.length || _vm.panelType == 5 && !_vm.equipmentList.length) ? _c('div', {
    staticClass: "empty"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/545.png")
    }
  }), _vm._v(" "), _vm._m(0)]) : _vm._e()]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.panelType == 1),
      expression: "panelType == 1"
    }],
    staticClass: "panel"
  }, [_c('div', {
    staticClass: "venue clearfix"
  }, _vm._l((_vm.caseList), function(item) {
    return _c('div', {
      staticClass: "item l"
    }, [_c('div', {
      staticClass: "imgbox"
    }, [_c('a', {
      attrs: {
        "href": 'caseDe.html?id=' + item.id,
        "target": "_blank"
      }
    }, [_c('div', {
      staticClass: "img"
    }, [_c('img', {
      attrs: {
        "src": item.coverUrl
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "length"
    }, [_vm._v(_vm._s(item.videoLength))])]), _vm._v(" "), _c('div', {
      staticClass: "bg summary"
    }, [_c('p', [_vm._v(_vm._s(item.description))])])])]), _vm._v(" "), _c('div', [_c('div', {
      staticClass: "attr"
    }, [_c('div', {
      staticClass: "title"
    }, [_c('a', {
      attrs: {
        "href": 'caseDe.html?id=' + item.id,
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('i', {
      staticClass: "keep r",
      on: {
        "click": function($event) {
          return _vm.cancelCaseKeep(item.id)
        }
      }
    })]), _vm._v(" "), _c('ul', {
      staticClass: "tag clearfix"
    }, _vm._l((item.typeStr), function(ys, yi) {
      return (yi < 3) ? _c('li', {
        staticClass: "l"
      }, [_c('span', [_vm._v(_vm._s(ys))])]) : _vm._e()
    }), 0)]), _vm._v(" "), _c('div', {
      staticClass: "author"
    }, [_c('a', {
      attrs: {
        "href": 'userPage.html?id=' + item.accountId
      }
    }, [_c('img', {
      attrs: {
        "src": item.faceUrl
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "name"
    }, [_vm._v(_vm._s(item.nickName))]), _vm._v(" "), _c('span', {
      staticClass: "role"
    }, [_vm._v("编剧策划/后期制作/灯光道具")])])])])])
  }), 0), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.totalPage / _vm.pageSize > 1),
      expression: "totalPage/pageSize>1"
    }],
    staticClass: "pager"
  }, [_c('Page', {
    attrs: {
      "total": _vm.totalPage,
      "page-size": _vm.pageSize,
      "current": _vm.currPage
    },
    on: {
      "on-change": _vm.onPageChange
    }
  })], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.panelType == 2),
      expression: "panelType == 2"
    }],
    staticClass: "panel"
  }, [_c('div', {
    staticClass: "team"
  }, _vm._l((_vm.producerList), function(item) {
    return _c('div', {
      staticClass: "item clearfix"
    }, [_c('div', {
      staticClass: "img l"
    }, [_c('a', {
      attrs: {
        "href": 'userPage.html?id=' + item.id,
        "target": "_blank"
      }
    }, [_c('img', {
      attrs: {
        "src": item.faceUrl,
        "width": "100",
        "height": "100"
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "info l"
    }, [_c('div', {
      staticClass: "title"
    }, [_c('a', {
      attrs: {
        "href": 'userPage.html?id=' + item.id,
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(item.nickName))]), _vm._v(" "), _c('span', {
      staticClass: "keep r",
      on: {
        "click": function($event) {
          return _vm.cancelProducerKeep(item.id)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "summary"
    }, [_vm._v(_vm._s(item.summary))])]), _vm._v(" "), _c('div', {
      staticClass: "works l clearfix"
    }, [_vm._l((item.sampleList), function(v, i) {
      return (i < 3) ? _c('div', {
        staticClass: "work"
      }, [_c('img', {
        attrs: {
          "src": v.coverUrl
        }
      }), _vm._v(" "), _c('div', {
        staticClass: "bg"
      }), _vm._v(" "), _c('a', {
        attrs: {
          "href": 'caseDe.html?id=' + v.id,
          "target": "_blank"
        }
      }, [_vm._m(1, true)]), _vm._v(" "), _c('p', [_vm._v(_vm._s(v.title))])]) : _vm._e()
    }), _vm._v(" "), _vm._l((item.random), function(rd) {
      return _c('div', {
        staticClass: "work"
      }, [_c('img', {
        staticStyle: {
          "width": "100%",
          "height": "100%"
        },
        attrs: {
          "src": _vm.mathImg[rd]
        }
      })])
    })], 2)])
  }), 0), _vm._v(" "), (_vm.totalPage / _vm.pageSize > 1) ? _c('div', {
    staticClass: "pager"
  }, [_c('Page', {
    attrs: {
      "total": _vm.totalPage,
      "page-size": _vm.pageSize,
      "current": _vm.currPage
    },
    on: {
      "on-change": _vm.onPageChange
    }
  })], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.panelType == 3),
      expression: "panelType == 3"
    }],
    staticClass: "panel"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "actor clearfix"
  }, _vm._l((_vm.actorList), function(item) {
    return _c('div', {
      staticClass: "item l clearfix"
    }, [_c('div', {
      staticClass: "img l"
    }, [_c('a', {
      attrs: {
        "href": 'talentActor.html?id=' + item.id,
        "target": "_blank"
      }
    }, [_c('img', {
      attrs: {
        "src": item.coverUrl
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "info l"
    }, [_c('div', {
      staticClass: "h4"
    }, [_c('a', {
      attrs: {
        "href": 'talentActor.html?id=' + item.id,
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), (_vm.panelbar == 1) ? _c('span', {
      staticClass: "bgyellow"
    }, [_vm._v("演员")]) : _vm._e(), _vm._v(" "), (_vm.panelbar == 3) ? _c('span', {
      staticClass: "bgred"
    }, [_vm._v("KOL")]) : _vm._e(), _vm._v(" "), (_vm.panelbar == 4) ? _c('span', {
      staticClass: "bgblue"
    }, [_vm._v("配音")]) : _vm._e(), _vm._v(" "), _c('i', {
      staticClass: "keep r",
      on: {
        "click": function($event) {
          return _vm.cancelActorKeep(item.id)
        }
      }
    })]), _vm._v(" "), (_vm.panelbar == 1) ? _c('div', {
      staticClass: "tag"
    }, [_c('span', [_vm._v("类型：" + _vm._s(_vm.getModelType(item.type)))]), _vm._v(" "), _c('span', [_vm._v("身高：" + _vm._s(item.height) + "cm")]), _vm._v(" "), _c('span', [_vm._v("体重：" + _vm._s(item.weight) + "kg")])]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "summary"
    }, [_vm._v(_vm._s(item.summary))])])])
  }), 0), _vm._v(" "), (_vm.totalPage / _vm.pageSize > 1) ? _c('div', {
    staticClass: "pager"
  }, [_c('Page', {
    attrs: {
      "total": _vm.totalPage,
      "page-size": _vm.pageSize,
      "current": _vm.currPage
    },
    on: {
      "on-change": _vm.onPageChange
    }
  })], 1) : _vm._e()])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.panelType == 4),
      expression: "panelType == 4"
    }],
    staticClass: "panel"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "venue clearfix"
  }, _vm._l((_vm.venueList), function(item) {
    return _c('div', {
      staticClass: "item l"
    }, [_c('div', {
      staticClass: "imgbox"
    }, [_c('a', {
      attrs: {
        "href": 'venueDetails.html?id=' + item.id + '&type=1'
      }
    }, [_c('img', {
      attrs: {
        "src": item.cover
      }
    })])]), _vm._v(" "), _c('div', [_c('div', {
      staticClass: "attr"
    }, [_c('div', {
      staticClass: "title"
    }, [_c('a', {
      attrs: {
        "href": 'venueDetails.html?id=' + item.id + '&type=1'
      }
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('i', {
      staticClass: "keep r",
      on: {
        "click": function($event) {
          return _vm.cancelVenueKeep(item.id)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "tag"
    }, [_c('span', [_vm._v(_vm._s(_vm._f("venueLocal")(item.location)))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.area) + "m²")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.typeStr))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.purposeStr))])])]), _vm._v(" "), _c('div', {
      staticClass: "author"
    }, [_c('a', {
      attrs: {
        "href": 'userPage.html?id=' + item.accountId
      }
    }, [_c('img', {
      attrs: {
        "src": item.faceUrl
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "name"
    }, [_vm._v(_vm._s(item.nickName))]), _vm._v(" "), _c('span', {
      staticClass: "role"
    }, [_vm._v("编剧策划/后期制作/灯光道具")])])])])])
  }), 0), _vm._v(" "), (_vm.totalPage / _vm.pageSize > 1) ? _c('div', {
    staticClass: "pager"
  }, [_c('Page', {
    attrs: {
      "total": _vm.totalPage,
      "page-size": _vm.pageSize,
      "current": _vm.currPage
    },
    on: {
      "on-change": _vm.onPageChange
    }
  })], 1) : _vm._e()])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.panelType == 5),
      expression: "panelType == 5"
    }],
    staticClass: "panel"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "venue clearfix"
  }, _vm._l((_vm.equipmentList), function(item) {
    return _c('div', {
      staticClass: "item l"
    }, [_c('div', {
      staticClass: "imgbox"
    }, [_c('a', {
      attrs: {
        "href": 'venueDetails.html?id=' + item.id + '&type=2'
      }
    }, [_c('img', {
      attrs: {
        "src": item.cover
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "info"
    }, [_c('div', {
      staticClass: "attr"
    }, [_c('div', {
      staticClass: "title"
    }, [_c('a', {
      attrs: {
        "href": 'venueDetails.html?id=' + item.id + '&type=2'
      }
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('i', {
      staticClass: "keep r",
      on: {
        "click": function($event) {
          return _vm.cancelEquipmentKeep(item.id)
        }
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "author"
    }, [_c('a', {
      attrs: {
        "href": 'userPage.html?id=' + item.accountId
      }
    }, [_c('img', {
      attrs: {
        "src": item.faceUrl
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "name"
    }, [_vm._v(_vm._s(item.nickName))]), _vm._v(" "), _c('span', {
      staticClass: "role"
    }, [_vm._v("编剧策划/后期制作/灯光道具")])])])])])
  }), 0), _vm._v(" "), (_vm.totalPage / _vm.pageSize > 1) ? _c('div', {
    staticClass: "pager"
  }, [_c('Page', {
    attrs: {
      "total": _vm.totalPage,
      "page-size": _vm.pageSize,
      "current": _vm.currPage
    },
    on: {
      "on-change": _vm.onPageChange
    }
  })], 1) : _vm._e()])])])])]), _vm._v(" "), _c('Footer')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('p', {
    staticClass: "etitle"
  }, [_vm._v("空空如也")]), _vm._v(" "), _c('p', [_vm._v("您还没有任何收藏哦～")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "shade"
  }, [_c('i')])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b43f55f6","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/collectionList/collectionList.vue
// module id = 1304
// module chunks = 33